var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 125,
    viewBox: "0 0 160 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5169 104.287C106.501 104.287 126.757 84.0702 126.757 59.0436C126.757 34.017 106.412 13.7998 81.5169 13.7998C56.5323 13.7998 36.2769 34.017 36.2769 59.0436C36.2769 84.0702 56.5323 104.287 81.5169 104.287Z",
    fill: "#EDDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.455 29.475C125.476 29.475 127.114 27.8362 127.114 25.8234C127.114 23.8106 125.476 22.1719 123.455 22.1719C121.435 22.1719 119.797 23.8106 119.797 25.8234C119.797 27.8362 121.435 29.475 123.455 29.475Z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.809 15.2248C130.189 15.2248 131.307 14.1116 131.307 12.7311C131.307 11.3506 130.189 10.2373 128.809 10.2373C127.429 10.2373 126.311 11.3506 126.311 12.7311C126.311 14.1116 127.429 15.2248 128.809 15.2248Z",
    fill: "#F6F7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5292 35.7096C33.9087 35.7096 35.0277 34.5964 35.0277 33.216C35.0277 31.8355 33.9087 30.7222 32.5292 30.7222C31.1497 30.7222 30.0308 31.8355 30.0308 33.216C30.0308 34.5964 31.1497 35.7096 32.5292 35.7096Z",
    fill: "#F6F7FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2709 105C48.8336 105 50.9109 102.925 50.9109 100.369C50.9109 97.8124 48.8336 95.7373 46.2709 95.7373C43.7082 95.7373 41.6309 97.8124 41.6309 100.369C41.6309 102.925 43.7082 105 46.2709 105Z",
    fill: "#F6F7FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_257_15711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 71.1561C138 82.6719 128.675 91.9789 117.046 91.9789C116.845 91.9789 115.141 91.9789 102.608 91.9789C93.8861 91.9789 79.95 91.9789 57.6923 91.9789H47.0649C33.1289 92.2728 22 81.1667 22 67.7538C22 54.2519 33.2288 43.039 47.3656 43.7426C59.4966 5.91774 115.041 11.217 119.752 50.3422C130.18 51.6425 138 60.4508 138 71.1561Z",
    fill: "url(#paint0_linear_257_15711)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.046 91.979C128.575 91.979 138 82.672 138 71.1562C138 59.6493 128.575 50.3423 117.046 50.3423C105.515 50.3423 96.0918 59.6493 96.0918 71.1562C96.0918 82.672 105.515 91.979 117.046 91.979Z",
    fill: "url(#paint1_linear_257_15711)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8572 92.1748C103.411 92.1748 120.154 75.5647 120.154 55.0447C120.154 34.5336 103.411 17.9233 82.8572 17.9233C62.3038 17.9233 45.5605 34.5336 45.5605 55.0447C45.5605 75.5647 62.2039 92.1748 82.8572 92.1748Z",
    fill: "url(#paint2_linear_257_15711)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05 51.02C75.05 52.69 73.7 54.05 72.03 54.05C70.35 54.05 69 52.69 69 51.02C69 49.35 70.35 48 72.03 48C73.7 48 75.05 49.35 75.05 51.02Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9099 51.02C91.9099 52.69 90.5599 54.05 88.8899 54.05C87.2199 54.05 85.8599 52.69 85.8599 51.02C85.8599 49.35 87.2199 48 88.8899 48C90.5599 48 91.9099 49.35 91.9099 51.02Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.85 69.1301H73.0599C70.7099 69.1301 69.4 66.5001 70.78 64.5701C71.82 63.1201 73.13 61.94 74.65 61.04C76.38 60.08 78.38 59.52 80.46 59.52C82.95 59.52 85.23 60.2801 87.16 61.6001C88.34 62.4301 89.37 63.3901 90.2 64.5701C91.52 66.5001 90.2 69.1301 87.85 69.1301Z",
    fill: "#D6DCE8",
    stroke: "#D6DCE8",
    strokeWidth: 1.7035,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6401 69.1304H75.3401C75.2701 68.9904 75.2701 68.8502 75.3401 68.7202C76.1001 66.5702 78.1102 65.0503 80.5302 65.0503C82.9502 65.0503 84.9501 66.5702 85.7101 68.7202C85.7101 68.8502 85.7101 68.9904 85.6401 69.1304Z",
    fill: "#AAB2C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1598 62.2903V62.8403C87.1598 63.2603 86.8197 63.5303 86.4697 63.5303H75.4098C74.9998 63.5303 74.7197 63.1903 74.7197 62.8403V61.7402C76.4497 60.7702 78.4498 60.2202 80.5298 60.2202C82.9398 60.2202 85.2298 60.9803 87.1598 62.2903Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5027 20.9693C40.7124 20.1499 41.5485 19.6512 42.3712 19.8649L48.19 21.3344C49.0127 21.5481 49.5097 22.3854 49.3009 23.2048C49.0912 24.0242 48.2551 24.5229 47.4324 24.3091L41.6145 22.8396C40.7909 22.6258 40.2939 21.7887 40.5027 20.9693Z",
    fill: "#6400FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.447 4.64465C46.1493 4.16371 47.1049 4.35081 47.5823 5.0455L54.5369 15.2788C55.0134 15.9735 54.8305 16.9264 54.1283 17.4074C53.426 17.8794 52.4704 17.7012 51.993 16.9976L45.0383 6.77326C44.561 6.06966 44.7439 5.11668 45.447 4.64465Z",
    fill: "#6400FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3481 0.0309001C59.1806 -0.138319 59.9899 0.404941 60.155 1.23322L62.5589 13.3635C62.724 14.1918 62.1823 15.0023 61.3498 15.1626C60.5164 15.3318 59.7079 14.7886 59.5429 13.9603L57.139 1.82998C56.9739 1.0017 57.5155 0.191213 58.3481 0.0309001Z",
    fill: "#6400FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.634 30.2569C129.249 31.9219 128.672 33.5221 127.966 34.9929C126.107 38.4431 123.349 41.255 119.887 42.9847C116.295 44.8347 112.062 45.473 107.766 44.6405C97.7615 42.5315 91.2847 32.8191 93.4009 22.7829C95.5171 12.7467 105.201 6.29032 115.269 8.3993C118.86 9.16705 122.003 10.8967 124.632 13.3849C128.992 17.8619 130.852 24.1889 129.634 30.2569Z",
    fill: "#6400FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.356 21.9809L118.265 25.0626L120.637 27.4255C120.772 27.5617 120.848 27.7458 120.848 27.9376C120.848 28.1294 120.772 28.3134 120.637 28.4497C120.5 28.5825 120.316 28.6568 120.125 28.6568C119.934 28.6568 119.75 28.5825 119.613 28.4497L119.047 27.8747L114.402 32.5196C113.727 33.1922 112.813 33.5699 111.86 33.5699C110.906 33.5699 109.992 33.1922 109.317 32.5196L107.906 31.109L103.387 35.6372C103.25 35.77 103.066 35.8443 102.875 35.8443C102.684 35.8443 102.5 35.77 102.363 35.6372C102.228 35.5009 102.152 35.3169 102.152 35.1251C102.152 34.9333 102.228 34.7492 102.363 34.613L106.891 30.0938L105.481 28.6833C104.808 28.008 104.43 27.0938 104.43 26.1407C104.43 25.1876 104.808 24.2733 105.481 23.5981L110.126 18.9532L109.551 18.3872C109.436 18.2475 109.377 18.0702 109.386 17.8898C109.395 17.7093 109.471 17.5386 109.598 17.4109C109.726 17.2832 109.897 17.2075 110.077 17.1986C110.258 17.1898 110.435 17.2483 110.575 17.363L112.938 19.7348L116.019 16.6442C116.159 16.5296 116.336 16.471 116.517 16.4799C116.697 16.4887 116.868 16.5644 116.996 16.6922C117.123 16.8199 117.199 16.9906 117.208 17.171C117.217 17.3515 117.158 17.5288 117.043 17.6684L113.953 20.7501L117.25 24.0473L120.332 20.9567C120.471 20.8421 120.649 20.7835 120.829 20.7924C121.01 20.8012 121.18 20.8769 121.308 21.0047C121.436 21.1324 121.511 21.3031 121.52 21.4835C121.529 21.664 121.471 21.8413 121.356 21.9809Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_257_15711",
    x: 0,
    y: 7.01416,
    width: 160,
    height: 117.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.25098 0 0 0 0 0.266667 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_257_15711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_257_15711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_257_15711",
    x1: 80,
    y1: 48.5787,
    x2: 79.9627,
    y2: 92.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_257_15711",
    x1: 93.8619,
    y1: 45.8624,
    x2: 112.399,
    y2: 66.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_257_15711",
    x1: 42.0681,
    y1: 38.0158,
    x2: 71.3309,
    y2: 49.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b50b17fc066e59aeb88ff74ab497ee94.svg";
export { ForwardRef as ReactComponent };